<template>
  <div class="carousel_box">
    <!-- 轮播图 -->
    <div class="carousel">
      <a-carousel autoplay>
        <div
          v-for="item in bannerImg"
          :key="item.id"
          :style="
            item.classify == 2 || item.classify == 3 ? 'cursor:pointer' : ''
          "          
          style="height: 17rem"
        >
          <img @click="onClick(item)" style="object-fit: cover" :src="imgPrefix + item.pic" alt="" />
        </div>
      </a-carousel>
    </div>
    <div
      class="w flex"
      style="height: 17rem;"
    >
      <div class="ban_l">
        <span class="tit">
          {{ bannerInfo.title }}
        </span>
        <br />
        <span class="desc">
          {{ bannerInfo.desc }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import imgPrefix from "../../utils/imgPrefix";
export default {
  props: {
    bannerImg: {
      // type:'Array',
      // default:[]
    },
    bannerInfo: {},
  },
  components: {},
  data() {
    return {
      imgPrefix,
    };
  },
  created() {},
  mounted() {},
  methods: {
    onClick(val) {
      if (val.classify == "2") {
        //内链
        this.$router.push(val.link);
      } else if (val.classify == "3") {
        //外链
        window.open(val.link);
      }
    },
  },
};
</script>

<style scoped lang="less">
.carousel_box{
  height: 17rem;
  opacity: 0.8;
  background: linear-gradient(90deg, #335B7D 0%, rgba(51, 91, 125, 0.50) 100%);
}
/deep/.ant-carousel .slick-slide img {
  display: inline;
  width: 100%;
  height: 100%;
}
</style>
